<template>
  <div>

    <!-- Story Modal -->
    <b-toast
        id="story-sidebar-toast-skip"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showSkipToast"
        :auto-hide-delay="5000"
        :no-close-button="true"
        @hidden="showSkipToast=false"
      >
        Story skipped to end, click Argo for training options
    </b-toast>
    <b-modal
      id="story-modal"
      hide-header
      hide-footer
      size="lg"
      :modal-class="'story-modal-component'"
    >
      <div class="story-modal">
        <img v-if="Progression.storyIndex < Object.keys(storyInstructions.valuation[Progression.stepIndex].story).length - 1" class="confirm-next-button-image-1" src="./assets/panel-next-button.png"/>
        <button
          v-if="Progression.storyIndex < Object.keys(storyInstructions.valuation[Progression.stepIndex].story).length - 1"
          class="confirm-next-button-1"
          @click="replacePanelText"
        >
        continue
        </button>
        <button
          v-else
          class="confirm-next-button-2"
          @click="completePanelText"
        >
          <img class="confirm-next-button-image-2" src="./assets/panel-confirm-button.png"/>
        </button>
        <typewriter ref="typewriter" class="typewriter" :type-interval="1" :replace-interval="1">
          <div class="typewriter-text">
            {{storyInstructions.valuation[Progression.stepIndex].story[Progression.storyIndex]}}
          </div>
        </typewriter>
        <button class="skip-button" @click="skipStoryProgress">
          skip
        </button>
      </div>
    </b-modal>

    <main role="main" class="container">
      <div>
        <div v-if="load_state == -1" class="row">
          <div class="col">
            <h2>Loading....please wait</h2>
          </div>
        </div>
        <div v-else class="col main-content">
          <div class="flex-row">
            <b-pagination-nav
              id="token-pagination-popover"
              class="token-nav" :link-gen="linkGen" :number-of-pages="totalSupply" use-router>
              <template #first-text><span class="text-primary">&#60;&#60;</span></template>
              <template #prev-text><span class="text-primary">&#60;</span></template>
              <template #next-text><span class="text-primary">&#62;</span></template>
              <template #last-text><span class="text-primary">&#62;&#62;</span></template>
              <template #page="{ page, active }">
                  <b v-if="active" class="text-warning">{{ page }}</b>
                  <span v-else class="text-info">{{ page }}</span>
                </template>
            </b-pagination-nav>
          </div>
          <b-input-group 
            id="token-search-popover"
            class="search" @keyup.enter="searchToken">
            <b-form-input
              v-model="tokenToSearch"
              class="search-input"
              type="text"
              placeholder="Search for a Zoombies Token"
            />
            <b-input-group-append>
              <b-button variant="success" @click="searchToken"> Go </b-button>
            </b-input-group-append>
          </b-input-group>
          <div v-if="load_state == 0" class="row">
            <div class="col">
              <h2>
                Zoombies Token #{{ token_id }} does not exist on this chain
              </h2>
              <p>Please search for a valid token</p>
            </div>
          </div>
          <div v-else class="row">
            <div v-if="1==0" class="col-sm text-center"><br/>
              <a href="https://zoombies.world/valuator/" target="_blank" class="text-white btn btn-success btn-sm">What is this ?</a><br/>
              <br/>
              <h4 class="valuation-label">NFT Value Score</h4>
              
              Most Valuable = 100

              <apexchart
                id="chartContainer"
                ref="scarcityChart"
                width="100%"
                type="radialBar"
                :options="chartOptions"
                :series="chartSeries"
              ></apexchart>
            </div>
            <div>
              <b-card text-variant="white" class="my-info-panel">
                <b-card-text>
                  <span class="valuation-label">Valuation Data:</span><br/>
                  <strong>Edition Maximum:</strong> {{edition_max}}<br/>
                  <strong>Total in circulation:</strong> {{total_circulation}}<br/>
                  <strong>Total Minted:</strong> {{total_minted}}<br/>
                  <strong>Total Sacrificed:</strong> {{total_sacrificed}}<br/>
              </b-card-text>
            </b-card>

            </div>
            <div id="card-wrapper" class="col-sm">
              <OwnedCardContent
                :id="card.id"
                :key="card.id"
                :type_id="card.attributes.type_id"
                :name="card.name"
                :cost="card.attributes.cost"
                :cset="card.attributes.card_set"
                :edition_current="edition_current"
                :edition_total="card.attributes.edition_total"
                :level="card.attributes.card_level"
                :unlock_czxp="card.attributes.unlock_czxp"
                :buy_czxp="card.attributes.buy_czxp"
                :sacrifice_czxp="card.attributes.sacrifice_czxp"
                :image="card.image"
                :card_class="card.attributes.rarity"
                :in_store="card.attributes.in_store"
                :card_owned="true"
                :is_single_card_view="true"
              />
            </div>
            <div id="stats-container" class="col-sm my-info-panel">
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Owner:</div>
                <div>
                  <a class="wrap-text" :href="owner_url">{{
                    owner.substr(0, 8) + "..." + owner.substr(36)
                  }}</a>
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">
                  Date Minted:
                </div>
                <div class="">
                  {{ minted_date }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">
                  NFT #:
                </div>
                <div class="">
                  {{ token_id }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Card Name:</div>
                <div class="">
                  {{ card.name }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Edition:</div>
                <div class="">
                  {{ edition_current }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Foil Card:</div>
                <div class="">
                  {{ isFoil }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Card Set:</div>
                <div class="">
                  {{ card.attributes.card_set }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">
                  Type Released:
                </div>
                <div class="">
                  {{ released_date }}
                </div>
              </div>


              <div class="flex-row mt-2">
                <div class="text-right font-weight-bold label">
                  Zombie Type:
                </div>
                <div class="">
                  {{ card.attributes.zombie_type }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Rarity:</div>
                <div class="">
                  {{ rarity }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">GLMR Cost:</div>
                <div class="">
                  {{ card.attributes.cost }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Earn/Burn ZOOM:</div>
                <div class="">
                  {{ parseInt(card.attributes.buy_czxp).toLocaleString() }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">
                  Sacrifice ZOOM:
                </div>
                <div class="">
                  {{ parseInt(card.attributes.sacrifice_czxp).toLocaleString() }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">
                  Unlock ZOOM:
                </div>
                <div class="">
                  {{   parseInt(card.attributes.unlock_czxp).toLocaleString() }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-right font-weight-bold label">Level:</div>
                <div class="">
                  {{ card.attributes.card_level }}
                </div>
              </div>
            </div>
          </div>
          <div class="description mb-5 my-info-panel">
            {{ card.attributes.description }}
          </div>
          <h3 class="transfer-history">Zoombie NFT #{{token_id}} Transfer History</h3>
          <div class="flex-row">
            <b-table
              stacked="sm"
              bordered
              striped
              thead-tr-class="my-thead"
              table-class="my-info-panel"
              :items="items"
            ></b-table>
          </div>
        </div>
        <div v-if="isMobileNotConnected||isDesktopNotConnected" class="install-container">
          <a href="https://metamask.io/" target="_blank" class="install-text">Install Metamask</a>
        </div>
      </div>
    </main>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==1" target="token-search-popover" triggers="hover manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.valuation[2].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==2" target="token-pagination-popover" triggers="hover manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.valuation[2].popovers[2].content }}
      </div>
    </b-popover>
  </div>
</template>

<script>
import './assets/global.css';
import { CURR_CHAIN } from "../util/constants/networks";
import axios from "axios";
import OwnedCardContent from "@/components/OwnedCardContent.vue";
import dAppStates from "@/dAppStates";
import apexchart from "vue-apexcharts";
import {
  BButton,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BTable,
  BCard,
  BCardText,
  BPaginationNav,
  BPopover
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import Typewriter from "typewriter-vue";
import Progress from './Progress.js';
import storyInstructions from "./story-instructions.json";
import { Progression } from './Progression.js'

export default {
  name: "TokenContent",
  components: {
    OwnedCardContent,
    BTable,
    BCard,
    BCardText,
    BButton,
    BInputGroup,
    BFormInput,
    BPaginationNav,
    BInputGroupAppend,
    apexchart,
    BPopover,
    Typewriter,
  },
  data() {
    return {
      storyInstructions,
      Progression,
      showSkipToast: false,
      load_state: -1, //This is the loading state, -1 = loading state,0 - token doesn't exist, 1 = token is valid
      owner: "Loading..",
      token_id: "",
      minted_date: "Fetching...",
      edition_max: "Fetching...",
      total_minted: "Fetching...",
      total_sacrificed: "Fetching...",
      total_circulation: "Fetching...",
      totalSupply: 2866,
      ZVScore: 0,
      card: {
        id: null,
        name: "Loading...",
        attributes: {
          rarity: "Loading...",
          edition_total: "Loading...",
          cost: "Loading...",
          card_set: "Loading...",
          zombie_type: "Loading...",
          buy_czxp: "Loading...",
          sacrifice_czxp: "Loading...",
          unlock_czxp: "Loading...",
          card_level: "Loading...",
          description: "Loading...",
        },
      },
      owner_url: "",
      rarity: "",
      released_date: "Loading..",
      edition_current: "Loading...",
      isFoil: "Loading...",
      etherscan_token_id:
        "https://blockscout.moonriver.moonbeam.network/tokens/",
      tokenToSearch: "",
      chartSeries: [0],
      chartOptions: {
        chart: {
          type: 'radialBar',
        },
        labels: [""],
        colors: ["#f8ff01"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            gradientToColors: ["#28a745"],
            stops: [0, 100]
          }
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                show: false,
                color: "#fff",
                fontSize: "16px"
              },
              value: {
                show: true,
                offsetY: 8,
                color: "#fff",
                fontSize: '25px',
                formatter: function (value) {
                  return (value + " ")
                }
              },
            }
          },
        },

      },
      items: [
        {
          date_transferred: "Loading...",
          from: 'Loading...',
          to: 'Loading...',
        },
      ],
    };
  },
  computed: {
    isMobileNotConnected() {
      if(!window.ethereum && (window.innerWidth < 415)) {
        return true;
      }
      else {
        return false;
      }
    },
    isDesktopNotConnected() {
      if(!window.ethereum && (window.innerWidth >= 415)) {
        return true;
      }
      else {
        return false;
      }
    },
    isDAppConnected() {
      return (
        this.$store.state.dAppState === dAppStates.CONNECTED ||
        this.$store.state.dAppState === dAppStates.WALLET_CONNECTED
      );
    },
    ...mapGetters({
      getReadOnlyZoombiesContract: "blockChain/getReadOnlyZoombiesContract",
      getTotalNftSupply: "blockChain/getTotalNftSupply",
    }),
  },
  watch: {
    getReadOnlyZoombiesContract(value) {
      if (value) {
        this.loadCard(this.token_id);
        this.getZVScore();
      }
    },
    "$route.params.token_id": function (id) {

      this.token_id = parseInt(id);
      this.getZVScore();
      this.loadCard(this.token_id);
    },
  },
  created() {
    this.ProgressInstance = new Progress();
    const progress = this.ProgressInstance.getProgress();

    if (progress.hasOwnProperty('valuation')) {
      Progression.stepIndex = progress.valuation;
    } else {
      Progression.stepIndex = 1;
    }
    this.ProgressInstance.updateProgress({name: 'valuation', value: Progression.stepIndex});

  },
  mounted() {
    this.$root.$on('bv::popover::show', bvEventObj => {
      Progression.popOverSound.play();
    })

    this.$nextTick(() => {
      Progression.storyIndex = 0;

      const progress = this.ProgressInstance.getProgress();
      if (progress.hasOwnProperty('valuation')) {
        Progression.stepIndex = progress.valuation;
      } else {
        Progression.stepIndex = 1;

      }

      if (progress.valuationCompleted === false) {
        Progression.popOverSound.play();
        Progression.typingSound.currentTime = 83;
        Progression.typingSound.play();
        this.$bvModal.show('story-modal');
      }
    });

    //grab the token id from the url
    this.token_id = parseInt(this.$route.params.token_id);
    if (this.isDAppConnected) {
      this.totalSupply = this.getTotalNftSupply;
      this.getZVScore();
      this.loadCard(this.token_id);
    }
  },
  methods: {
    replacePanelText() {
      if (Progression.storyIndex < storyInstructions.valuation[Progression.stepIndex].story.length - 1) {

        Progression.typingSound.currentTime = (Math.random() * 3) + 82;
        Progression.typingSound.play();

        this.$refs.typewriter.replaceText({
          from: storyInstructions.valuation[Progression.stepIndex].story[Progression.storyIndex],
          to: storyInstructions.valuation[Progression.stepIndex].story[Progression.storyIndex + 1],
        });
      }
      
      Progression.storyIndex++;

    },
    completePanelText() {
      this.$bvModal.hide('story-modal');

      // if (Progression.storyIndex === 4 && Progression.stepIndex === 7) {
      //   this.$bvModal.hide('sponsor-modal');
      // } 

      Progression.stepIndex++;
      this.ProgressInstance.updateProgress({name: 'valuation', value: Progression.stepIndex});

      if (Progression.stepIndex > Object.keys(storyInstructions.valuation).length) {
        Progression.stepIndex = Object.keys(storyInstructions.valuation).length;
        this.ProgressInstance.updateProgress({name: 'valuation', value: Progression.stepIndex});

        this.ProgressInstance.updateProgress({name: 'valuationCompleted', value: true});
        Progression.storyIndex = 4; // Specific for this page
        Progression.storyCompletedSound.play();
      } else {
        this.$bvModal.show('story-modal');
        Progression.progressStepSound.play();
        Progression.storyIndex = 0; // placeholder value
        this.ProgressInstance.updateProgress({name: 'valuationCompleted', value: false});
      }
    },
    skipStoryProgress() {
      this.showSkipToast = true;
      Progression.stepIndex = Object.keys(storyInstructions.valuation).length;// Specific for this page
      Progression.storyIndex = 3;
      this.ProgressInstance.updateProgress({name: 'valuationCompleted', value: true});

      this.completePanelText();
    },
    linkGen(pageNum) {
        return pageNum === 1 ? '1' : `${pageNum}`
    },
    getZVScore: async function () {
      //Moonbeam NOT ready. just return
      return;


      console.log("Get ZVScore for token ", this.token_id);
      try {
        const result = await fetch(
          `https://api.zoombies.world/valuator/getZVScore/${this.token_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        const res = await result.json();
        console.log(res);
        console.log("ZVScore got :", res.Score);
        this.ZVScore = res.Score;
        this.chartSeries= [res.Score];
      }catch(e){
        console.error("getZVScore FAILED:", e.message);
      }
    },
    querySubGraph: async function (cardTypeId) {
      const query = `query {
                        nftTransfers(
                          filter:{
                            tokenId: {
                              equalTo: "${this.token_id}"
                            },
                            network :{
                              equalTo : ${window.ethereum.networkVersion}
                            }
                          }, orderBy : BLOCK_TIMESTAMP_ASC
                        ){
                          nodes {
                            blockTimestamp
                            from
                            to
                          }
                        }
                        logCardMinteds(
                          filter:{
                            cardTypeId: {
                              equalTo: ${cardTypeId}
                            },
                            network :{
                              equalTo : ${window.ethereum.networkVersion}
                            }
                          }, orderBy : BLOCK_TIMESTAMP_ASC
                        ){
                          totalCount
                        }
                        logSacrificeNFTs(
                          filter: {
                            cardTypeId: {
                              equalTo: "${cardTypeId}"
                            },
                            network :{
                              equalTo : ${window.ethereum.networkVersion}
                            }
                          }
                        ){
                          totalCount
                        }
                      }`;

      const graphEndPoint = "https://cryptoz.cards:3000"

      try {
        const result = await fetch(
          graphEndPoint,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              query,
            }),
          }
        );
        const res = await result.json();
        //console.log("QUERY res:",res);
        //Filter the result set for this token
        const found = res.data.nftTransfers.nodes.find(element => element.from == "0x0000000000000000000000000000000000000000");
        if(found == undefined) {
          throw 'No minted NFTs found for NFT #'+this.token_id+', Please let us know in the Discord #Support channel'
        }

        //console.log(cardTypeId,this.token_id,found);

        this.minted_date = new Date(found.blockTimestamp).toLocaleString();
        this.total_minted = res.data.logCardMinteds.totalCount;
        this.total_sacrificed = res.data.logSacrificeNFTs.totalCount;
        this.total_circulation = this.total_minted - this.total_sacrificed;

        this.items = res.data.nftTransfers.nodes.reverse();

      }catch(e){
        window.alert("There was a fatal error contacting SubQuery Servers,Please let us know in the Cardinal Entertainment Discord #support channel");
        console.log("SubQuery fetch error:",e);
        return;
      }
    },
    loadCard: async function (token_id) {
      if (!this.getReadOnlyZoombiesContract) return;
      try {
        const res = await this.getReadOnlyZoombiesContract.nfts(token_id);
        //returns TypeId, Edition #, isFoil
        let cardTypeId = parseInt(res[0]);

        //If the tokenId is greater than 0, we have something valid
        if (cardTypeId === 0) {
          this.load_state = 0;
          return;
        }
        this.querySubGraph(cardTypeId);
        this.edition_current = parseInt(res[1]);
        if(res.isFoil){
          this.isFoil = "Yes";
        }else{
          this.isFoil = "No";
        }
        this.getCardData(cardTypeId);
        const owner = await this.getReadOnlyZoombiesContract.ownerOf(token_id);
        this.owner = owner;
        this.owner_url = this.getCryptLink(owner);
        const releaseTime = await this.getReadOnlyZoombiesContract.storeReleaseTime(
          cardTypeId
        );
        this.released_date = new Intl.DateTimeFormat("en-US", {
          dateStyle: "full",
          timeStyle: "long",
        }).format(releaseTime * 1000);
      } catch (error) {
        console.error({ error });
      }
    },
    getCryptLink(owner) {
      // let url;
      // if (window.location.pathname === "/moonbase") {
      //   url = "https://moonbase.zoombies.world";
      // } else if (process.env.NODE_ENV === "development") {
      //   url = "localhost:8080";
      // } else {
      //   url = "https://movr.zoombies.world";
      // }

      // New implementation below

      let url;
            
      if (process.env.NODE_ENV === "development") {
        url = "localhost:8080";
      } else {
        url = "https://zoombies.world";
      }

      let curr_chain;
      if(window.ethereum.networkVersion == 1287) {
        curr_chain = 'moonbase';
      }
      else if(window.ethereum.networkVersion == 1284) {
        curr_chain = 'moonbeam';
      }

      return `${url}/${curr_chain}/my-zoombies-nfts/${owner}`;
    },
    getCardData: async function (card_id) {
      const cardType = await import(`../card_types/${card_id}.json`);
      const res = {
        data: {
          ...cardType.default,
        },
      };
      this.handleGotCardData(res);
    },
    handleGotCardData: function (res) {
      //console.log(res.data);

      var newAttr = [];
      //format the attributes to match our JS objects
      res.data.attributes.forEach(function (element) {
        newAttr[element.trait_type] = element.value;
      });

      //Overwrite our JSON reponse with vue friendly card binding data
      res.data.attributes = newAttr;

      //Get the human label for rarity
      this.rarity = res.data.attributes.rarity;

      //Append the bg
      switch (res.data.attributes.rarity) {
        case "Common":
          res.data.attributes.rarity = "card-bg card-bg-6";
          break;
        case "Uncommon":
          res.data.attributes.rarity = "card-bg card-bg-5";
          break;
        case "Rare":
          res.data.attributes.rarity = "card-bg card-bg-4";
          break;
        case "Epic":
          res.data.attributes.rarity = "card-bg card-bg-3";
          break;
        case "Platinum":
          res.data.attributes.rarity = "card-bg card-bg-2";
          break;
        case "Diamond":
          res.data.attributes.rarity = "card-bg card-bg-1";
          break;
      }

      if (res.data.attributes.edition_total === 0) {
        res.data.attributes.cost = "Booster";
      }

      this.edition_max = (res.data.attributes.edition_total == 0) ? 'Unlimited' : res.data.attributes.edition_total;
      this.card = res.data;
      this.card.id = this.token_id;
      this.load_state = 1;
    },
    searchToken() {
      const tokenId = this.tokenToSearch.replace("#", "");
      this.$router.replace(tokenId);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding-top: 20px;
}

a {
  color: #7ef4f6;
}

.row {
  justify-content: center;
}

#stats-container {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.flex-row {
  display: flex;
}

.flex-row > * {
  flex: 1;
  min-width: 0;
}

.wrap-text {
  word-wrap: break-word;
}

.centered {
  display: flex;
  align-items: center;
}

.label {
  max-width: 200px;
  margin-right: 10px;
}

#card-wrapper {
  display: flex;
  justify-content: center;
}

.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.search {
  width: 50%;
  min-width: 300px;
  margin-bottom: 20px;
}

.description {
  font-size: 18px;
  font-weight: 500;
  margin-top: 20px;
}

.valuation-label, .transfer-history {
  font-family: 'Truculenta', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  color: #05e1ff;
  text-shadow: 1px 1px 2px black;
}
.install-container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  color: #eaca00;
}

.install-text {
  color: #eaca00;
}

.my-info-panel {
  padding: 10px;
  background-color: #1e162f;
  border: 3px solid;
  border-color: #00d1ff;
  border-radius: 15px;
  color: white;
}

.my-thead{
  color: red;
}

.token-nav {
  background-color: #1e162f;
}
</style>